import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'contentType'})

export class ContentTypePipe implements PipeTransform {
  public transform(value: string): string {
    switch (value) {
      case 'event':
        return 'Evento'

      case 'news':
        return 'Noticias'

      case 'program':
        return 'Programa'

      case 'blog':
        return 'Identidad 21'

      case 'basic_page':
        return 'Institucional'

      default:
        return ''
    }
  }
}
